import Page from "@/components/ui/Page/Page";
import PageTitle from "@/components/ui/Page/Title";
import PageBodyHeader from "@/components/ui/Page/BodyHeader";
import PageBody from "@/components/ui/Page/Body";

export default Page;
export { PageTitle, PageBodyHeader, PageBody };
